import { render, staticRenderFns } from "./natural-resources.vue?vue&type=template&id=0523cad5&scoped=true"
import script from "./natural-resources.vue?vue&type=script&lang=js"
export * from "./natural-resources.vue?vue&type=script&lang=js"
import style0 from "./natural-resources.vue?vue&type=style&index=0&id=0523cad5&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0523cad5",
  null
  
)

export default component.exports